import React from 'react';
import { IconProps } from '../IconProps';
const SvgMessage = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" {...props}>
    <g
      clipPath="url(#Message_svg__clip0_5081_13995)"
      stroke="#0D0300"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9.388 3.327c-.706-.179-1.918-.034-2.176 0A6.066 6.066 0 109.119 15.3a6.075 6.075 0 001.906-.71c.616.398 1.994.871 3.04.814-.77-.77-1.174-2.365-.814-3.039a6.05 6.05 0 00-1.196-7.535" />
      <path d="M7.387 1.052l2.441 2.343-2.343 2.442" />
    </g>
    <defs>
      <clipPath id="Message_svg__clip0_5081_13995">
        <path
          fill="#fff"
          transform="matrix(-1 0 0 1 16 .206)"
          d="M0 0h16v16H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMessage;
